import {Link, useLocation} from 'react-router-dom'
import styles from './styles.module.css'

function AIManagerPage() {
  const location = useLocation()
  const isHomePath = location.pathname === '/AIManager'
  const isPromptListPath = location.pathname === '/PromptManagerList'

  return (
    <div className={styles.page}>
      <aside className={styles.sideMenu}>
        <p className={styles.menuTitle}>AI Manager</p>
        <Link
          to="/AIManager"
          className={`${styles.menuLink} ${isHomePath ? styles.menuLinkActive : ''}`}
        >
          Home Ai Manager
        </Link>
        <Link
          to="/PromptManagerList"
          className={`${styles.menuLink} ${
            isPromptListPath ? styles.menuLinkActive : ''
          }`}
        >
          Prompt Manager
        </Link>
        <Link to="/ChatSocket" className={styles.menuLink}>
          Voltar ao sistema
        </Link>
      </aside>

      <section className={styles.content}>
        <div className={styles.breadcrumb}>
          <span className={styles.breadcrumbCurrent}>AI Manager</span>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCurrent}>Home</span>
        </div>
        <h2 className={styles.sectionTitle}>AI Manager</h2>
        <p className={styles.sectionDescription}>
          Área administrativa da IA. Use o menu lateral para acessar os módulos.
        </p>
      </section>
    </div>
  )
}

export default AIManagerPage

